const tabsNavElements = $('ul.tabs li');

tabsNavElements.on('click', function () {
    let tab_id = $(this).attr('data-tab');

    tabsNavElements.removeClass('is-current');
    $('.tab-content').hide();

    $(this).addClass('is-current');
    $(`#${tab_id}.tab-content`).fadeIn();
})